var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-router-view"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showRouterView),expression:"!showRouterView"}]},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRouterView),expression:"showRouterView"}]},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }